import styled from 'styled-components'

import { HEADER_HEIGHT_DESKTOP } from '../Quiz/components/Header/styled'

import { color, fontWeight } from 'src/styles'
import { media } from 'src/styles/media'
import { fontSize } from 'src/styles/fonts'

export const ContentWrap = styled.div`
  background-image: linear-gradient(238deg, #fffdee 100%, #fef7e2);
  min-height: 100%;
  padding-top: ${HEADER_HEIGHT_DESKTOP}rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Heading = styled.h2`
  font-size: ${fontSize.LARGE_XXXL};
  color: ${color.GREYISH_BROWN};
  font-weight: ${fontWeight.EXTRA};
  margin: 1.5rem 0 3rem;

  ${media.desktop} {
    margin: 2rem 0 6rem;
    font-size: 4rem;
  }
`

export const OrderedList = styled.ol`
  background-color: ${color.WHITE};
  min-width: 100%;
  margin: 0;
  padding-bottom: 2.4rem;
  padding-left: 5rem;
  flex-grow: 1;

  ${media.desktop} {
    flex-grow: 0;
    padding-bottom: 6rem;
    padding-top: 6rem;
    box-shadow: 0 1rem 3rem 0 rgba(0, 0, 0, 0.05);
    border-radius: 1.6rem;
    min-width: 102rem;
  }
`

export const ListItemInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2.4rem;

  ${media.desktop} {
    margin-top: 0;
    padding: 0.5rem 0;
    margin-right: 5rem;
  }
`

export const ListItem = styled.li`
  font-size: ${fontSize.SMALL};
  color: #c2c2c2;
  font-weight: ${fontWeight.EXTRA};
  padding-left: 2rem;

  ${media.desktop} {
    padding-left: 3.4rem;

    & + & {
      ${ListItemInner} {
        border-top: 0.1rem solid ${color.VERY_LIGHT_PINK};
      }
    }
  }
`

export const NameWrap = styled.span`
  font-size: initial;
  color: initial;
  font-weight: ${fontWeight.MEDIUM};
  margin-left: 1.7rem;

  ${media.desktop} {
    margin-left: 4.5rem;
  }
`

export const GetMoreWrap = styled.div`
  text-align: center;
  margin-right: 5rem;
  padding-top: 3rem;
`

export const SecondaryButton = styled.button`
  border-radius: 2.4rem;
  background-color: rgba(87, 61, 57, 0.15);
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  color: ${color.WARM_GREY};
  padding: 0.8rem 2.4rem;
`
